import { useState } from 'react';
import type { ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type FuseDialogProps = {
	open?: boolean;
	onClose?: () => void;
	title?: string;
	children?: ReactNode;
};

/**
 * FuseDialog component
 * Global dialog component for the application
 */
function FuseDialog(props: FuseDialogProps) {
	const { open = false, onClose, title, children } = props;
	const [isOpen, setIsOpen] = useState(open);

	const handleClose = () => {
		setIsOpen(false);
		onClose?.();
	};

	if (!isOpen && !open) {
		return null;
	}

	return (
		<Dialog
			open={open || isOpen}
			onClose={handleClose}
			maxWidth="sm"
			fullWidth
		>
			{title && (
				<DialogTitle>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-between"
					>
						{title}
						<IconButton
							aria-label="close"
							onClick={handleClose}
							size="small"
						>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			)}
			<DialogContent>{children}</DialogContent>
		</Dialog>
	);
}

export default FuseDialog;
